<script setup lang="ts">
const props = defineProps<{
  src: string
}>()

const backgroundUrl = computed(() => `url('${props.src}')`)
</script>

<template>
  <div class="bg-cover bg-center w-full h-full">
    <slot />
  </div>
</template>

<style scoped>
div {
  background-image: v-bind(backgroundUrl);
}
</style>
